import './style.scss'
import { FC, memo, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import * as Api from '@/api/account'
import ActivityModal from '@/components/ActivityModal'
import { UserStore } from '@/global-states'
import { eventTracking, showPlanModal } from '@/libs/util'
import SettingBanner from './components/Banner'
import NewUserPackage from './components/NewUserPackage'
import PointDetail from './components/PointDetail'
import UserDetail from './components/UserDetail'
import VipAgent from './components/VipAgent'
import VipCompany from './components/VipCompany'

const Setting: FC = () => {
  const { userPackage, payStatus } = UserStore
  const { t: translate } = useTranslation(['personal'])
  const [apiInfo, setApiInfo] = useState<any>({})
  const [activityModalOpen, setActivityModalOpen] = useState(false)
  const [searchParams] = useSearchParams()
  const recharge = searchParams.get('recharge')

  useEffect(() => {
    eventTracking('PersonalCenterPage')
    UserStore.checkUserPackage()
  }, [])

  useEffect(() => {
    if (payStatus) {
      setTimeout(() => {
        onPaySuccess()
      }, 300)
    }
  }, [payStatus])

  useEffect(() => {
    if (recharge) {
      showPlanModal()
    }
  }, [recharge])

  useEffect(() => {
    getApiInfo()
  }, [userPackage])

  const getApiInfo = async () => {
    if (userPackage?.current_membership_level >= 20) {
      const res = await Api.getApiInfo()
      setApiInfo(res || {})
    }
  }

  const onSub = () => {
    showPlanModal()
  }

  const onPaySuccess = async () => {
    await UserStore.updateUserPackage()
    getApiInfo()
  }

  const showActivity = () => {
    setActivityModalOpen(true)
  }

  return (
    <div className="page-common page-setting">
      <div className="common-header">{translate('personal.title')}</div>

      <div className="common-wrapper">
        {userPackage && (
          <>
            <div className="page-setting-user">
              <SettingBanner activityBannerClick={showActivity} />

              <UserDetail onSub={onSub} />

              <VipAgent />

              {userPackage.current_membership_level >= 20 && <VipCompany apiInfo={apiInfo} onSave={getApiInfo} />}

              <NewUserPackage />

              <PointDetail />
            </div>
          </>
        )}
      </div>

      <ActivityModal
        open={activityModalOpen}
        onCancel={() => {
          onPaySuccess()
          setActivityModalOpen(false)
        }}
      />
    </div>
  )
}

export default memo(Setting)
